import React from "react";
import { Card, Tabs } from "antd";
import FeederData from "./FeederData";
import AllFeederErrorLog from "./AllFeederErrorLog";
import CONSTANTS from "../../../util/constant/CONSTANTS";
import { role } from "../../../util/Route";

const DeviceDetails = () => {
    const menus = {
        feeder: <FeederData />,
        error: <AllFeederErrorLog />,
    };
    return (
        <>
            <div >

                <Card className="mt-5">
                    <Tabs
                        className="p-0 m-0"
                        defaultActiveKey="1"
                        size="middle"
                        type="card"
                        items={CONSTANTS.TAB_MENU.FEEDER.map((ele) => {
                            if (ele.Role?.includes(role)) {
                                return {
                                    label: `${ele.Label}`,
                                    key: `${ele.id}`,
                                    children: menus[ele?.id],
                                };
                            }
                        })}
                    />
                </Card>
            </div>
        </>
    );
};

export default DeviceDetails;
